// import { Link, Truck } from "lucide-react";
import { useState } from "react";
import { ListShuttles } from "./list-shuttles";
import { ListVessels } from "./list-vessels";

export const ListVesselsAndShuttles = () => {
  const [activeTab] = useState("vessels");

  return (
    <div className="space-y-6 bg-gray-50">
      {/* Header and Tabs */}
      {/* <div className="flex justify-between items-center">
        <h2 className="text-xl font-medium">Fleet Management</h2>
        <div className="flex space-x-4">
          <button
            className={`px-4 py-2 rounded-lg ${
              activeTab === "vessels"
                ? "bg-blue-100 text-blue-800"
                : "bg-gray-100 text-gray-600"
            }`}
            onClick={() => setActiveTab("vessels")}
          >
            <div className="flex items-center space-x-2">
              <Truck size={16} />
              <span>Vessels</span>
            </div>
          </button>
          <button
            className={`px-4 py-2 rounded-lg ${
              activeTab === "shuttles"
                ? "bg-blue-100 text-blue-800"
                : "bg-gray-100 text-gray-600"
            }`}
            onClick={() => setActiveTab("shuttles")}
          >
            <div className="flex items-center space-x-2">
              <Link size={16} />
              <span>Shuttles</span>
            </div>
          </button>
        </div>
      </div> */}

      {/* Vessels View */}
      {activeTab === "vessels" && <ListVessels />}

      {/* Shuttles View */}
      {activeTab === "shuttles" && <ListShuttles />}
    </div>
  );
};
